import React, { useEffect } from 'react';
import { initMetaPixel } from './utils/metaPixel';
import { Hero } from './components/Hero';
import { ProblemSection } from './components/ProblemSection';
import { SolutionSection } from './components/SolutionSection';
import { GlobalCompatibilitySection } from './components/GlobalCompatibilitySection';
import { InsideSection } from './components/InsideSection';
import { TransformationSection } from './components/TransformationSection';
import { SocialProofSection } from './components/SocialProofSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTASection } from './components/FinalCTASection';
import { SiteFooter } from './components/SiteFooter';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <div className="w-full bg-navy-900 font-sans" data-id="element-0" data-mp="28ufm24yk52fw">
      <Hero data-id="element-1" data-mp="28sutulzptvl7" />
      <main data-id="element-2" data-mp="28sl5t3y8dyi5">
        <ProblemSection data-id="element-3" data-mp="28s2x37udtrtc" />
        <SocialProofSection data-id="element-4" data-mp="23vkzcrxgytqi" />
        <GlobalCompatibilitySection data-id="element-5" data-mp="23ujksdh8vp41" />
        <InsideSection data-id="element-6" data-mp="23t8eo70bu59r" />
        <TransformationSection data-id="element-7" data-mp="3ik7eyd5x05p2" />
        <SolutionSection data-id="element-8" data-mp="3iiwasc8k4vxf" />
        <FAQSection data-id="element-9" data-mp="3ijpdn24eb1aa" />
        <FinalCTASection data-id="element-10" data-mp="3mlja0y7k5j4n" />
      </main>
      <SiteFooter data-id="element-11" data-mp="3mkhlps1j704z" />
    </div>;
}